import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import {  Box } from "@chakra-ui/react";
import "./detail.css";
// Components
import MaintenanceDetailMenu from "./menu/menu";
// Actions
import * as mainActions from "../../../redux/actions/main";
// Utils
import { getToastOpt } from "../../../utils/utils";

const MaintenanceDetail = ({ 
  primaryValue,
  primaryName,
  menuConfig,
  itemNameSingular, 
  itemIsMale = true,
  actions, 
  setIsLoading,
  renderDetail,
  setDetail,
  page,
  reload = true,
  setReload = () => {},
  onRemoved = () => {},
  isScrollable = true,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const detailRef = useRef(null);
  // States
  const [heightDetail, setHeightDetail] = useState(0);
  const [initialHeightDetail, setInitialHeightDetail] = useState(0);
  const [initialWindowInnerHeight,] = useState(window.innerHeight);
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => !!state.mainReducer.breadscrum[currentPage] ? state.mainReducer.breadscrum[currentPage] : []);

  /*
   * Use effects
   */

  useEffect(() => {
    if (!reload) return;
    // Get data
    getData();
    setReload(false);
  }, [reload]);
  
  /*
  * Resize control
  */

  useEffect(() => {
    if (!detailRef) return;
    const h = detailRef.current.clientHeight;
    setHeightDetail(h);
    setInitialHeightDetail(h);
  }, [detailRef]); 

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [initialHeightDetail]);

  const onResize = (e) => {
    // console.log("onResize", e);
    const diffW = Math.abs(initialWindowInnerHeight - window.innerHeight);
    const factor = window.innerHeight >= initialWindowInnerHeight ? 1 : -1;
    setHeightDetail(initialHeightDetail + (diffW * factor));
  };

  /*
   * Methods
   */

  const getData = async () => {
    setIsLoading(true);
    dispatch(actions.get(primaryValue)).then((response) => {
      setIsLoading(false);
      setDetail(response);
    }, err => {
      setIsLoading(false);
      toast(getToastOpt({
        title: `Error obtenint ${itemNameSingular}`,
        description: err,
        status: "error",
      }));
    });      
  };


  /*
   * Delete (action)
   */
  const remove = async () => {
    setIsLoading(true);
    dispatch(actions.remove(primaryValue)).then(
      (response) => {
        setIsLoading(false);
        dispatch(actions.setSelectedRows([]));
        toast(getToastOpt({
          title: `${itemNameSingular} ${itemIsMale ? "eliminat" : "eliminada"}`,
          status: "success",
          position: "top",
        }));
        // Raise event
        onRemoved();
        // Go back
        let goTo = currentPage;
        // Remove current item of breadscrum
        let updatedBreadscrum = breadscrum;
        if (breadscrum.length > 0) {
          updatedBreadscrum = breadscrum.slice(0, -1);
          dispatch(mainActions.setBreadscrum(currentPage, updatedBreadscrum));
        }
        if (updatedBreadscrum.length > 0) {
          const item = updatedBreadscrum[updatedBreadscrum.length - 1];
          goTo = item.path;
        }
        // Goto
        navigate(`/${goTo}`);
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error eliminant ${itemNameSingular}`,
          description: err,
          status: "error",
        }));
      }
    );
  };  

  /*
   * Render
   */

  return (
    <div id="maintenance-detail">
        <MaintenanceDetailMenu 
          primaryValue={primaryValue}
          primaryName={primaryName}
          config={menuConfig}
          itemNameSingular={itemNameSingular}
          itemIsMale={itemIsMale}
          onDelete={remove} 
          page={page}
        />
        <div className="maintenance-detail-content" ref={detailRef}>
          <Box className={isScrollable ? "scrollable" : ""} h={`${heightDetail - 0}px`}>
            {renderDetail()}
          </Box>
        </div>
    </div>
  );
};

export default MaintenanceDetail;
